import { ITenant } from '../pages/AbmLocalPage/types'
import { axiosInstanceMain } from '../utils/axiosGlobalUtils'

export const autocomplete = async (tenant: ITenant, value: string, soloActivos: boolean) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/locales/autocompletado?filtro=${soloActivos ? 'solo-activos' : 'todos'}`,
    { valor: value }
  )
